var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.isLoading && _vm.list.length !== 0
    ? _c("div", [
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              gap: "2rem",
              "max-width": "490px",
              "margin-top": "1rem"
            }
          },
          [
            _c("SelectJudicialStatus", {
              staticStyle: { "max-width": "235px" },
              model: {
                value: _vm.judicialStatusInBatch,
                callback: function($$v) {
                  _vm.judicialStatusInBatch = $$v
                },
                expression: "judicialStatusInBatch"
              }
            }),
            _vm._v(" "),
            _c(
              "b-overlay",
              {
                staticClass: "d-inline-block",
                attrs: {
                  show: _vm.busy,
                  rounded: "",
                  opacity: "0.6",
                  "spinner-small": "",
                  "spinner-variant": "secondary"
                }
              },
              [
                _c(
                  "b-button",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { disabled: !_vm.selectInvoiceInBatch.length },
                    on: { click: () => _vm.setJudicialStatusInBatch() }
                  },
                  [_vm._v("\n        Atualizar em lote\n      ")]
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex justify-content-between flex-column" },
          [
            _c(
              "Table",
              {
                staticClass: "overdue-invoice-table",
                staticStyle: { "margin-top": "1rem" }
              },
              [
                _c(
                  "TableHeader",
                  [
                    _c(
                      "TableRow",
                      _vm._l(_vm.overdueInvoiceColumns, function(
                        overdueInvoiceCol,
                        index
                      ) {
                        return _c(
                          "TableHead",
                          { key: `${overdueInvoiceCol}_${index}` },
                          [
                            _c("ColumnHeader", {
                              attrs: {
                                sort: overdueInvoiceCol.sort,
                                somatory: overdueInvoiceCol.somatory,
                                columnName: overdueInvoiceCol.name,
                                columnKey: overdueInvoiceCol.key,
                                columnType: overdueInvoiceCol.columnType,
                                currentColumnFiltered:
                                  _vm.currentColumnFiltered,
                                sortDirection: _vm.sortDirection,
                                dataList: _vm.list
                              },
                              on: {
                                sortListByKey: function($event) {
                                  return _vm.sortListByKey(
                                    overdueInvoiceCol.key
                                  )
                                }
                              }
                            })
                          ],
                          1
                        )
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "TableBody",
                  _vm._l(_vm.list, function(item, index) {
                    return _c(
                      "TableRow",
                      { key: `${item}_${index}` },
                      [
                        _c(
                          "TableCell",
                          { staticStyle: { "min-width": "95px" } },
                          [
                            _c("b-form-checkbox", {
                              attrs: { size: "sm" },
                              on: {
                                change: value =>
                                  _vm.setInvoiceInBatch(value, item.id)
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "TableCell",
                          { staticStyle: { "min-width": "95px" } },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(item.installationNumber) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "TableCell",
                          { staticStyle: { "min-width": "305px" } },
                          [
                            _c("RenderNameColumnValue", {
                              attrs: { name: item.name }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "TableCell",
                          {
                            staticStyle: {
                              "text-align": "right",
                              "min-width": "100px"
                            }
                          },
                          [
                            _c("RenderMoneyColumnValue", {
                              attrs: { value: item.boletoVeins }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "TableCell",
                          {
                            staticStyle: {
                              "text-align": "right",
                              "min-width": "100px"
                            }
                          },
                          [
                            _c("RenderDateColumnValue", {
                              attrs: { value: item.dueDate }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "TableCell",
                          [
                            _c("RenderDateColumnValue", {
                              attrs: {
                                value: item.referenceDate,
                                formatType: "ABBREVIATEDMONTH/YYYY"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "TableCell",
                          { staticStyle: { "text-align": "right" } },
                          [
                            _c(
                              "span",
                              { style: _vm.setColor(item.delayedDays) },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(item.delayedDays) +
                                    "\n            "
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "TableCell",
                          [
                            _c("RenderInstallationStatusColumnValue", {
                              attrs: { value: item.installationStatus }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "TableCell",
                          [
                            _c("DownloadInvoiceButton", {
                              attrs: { invoice: item }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "TableCell",
                          [
                            _c("RenderDateColumnValue", {
                              attrs: { value: item.fieldUpdateDate }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "TableCell",
                          {
                            style: _vm.setDayCountColor(
                              item.fieldUpdateDateDayCount
                            )
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(item.fieldUpdateDateDayCount) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "TableCell",
                          [
                            _c("SelectJudicialStatus", {
                              on: {
                                input: function($event) {
                                  return _vm.changeInvoiceJudicialStatus(item)
                                }
                              },
                              model: {
                                value: item.judicialStatus,
                                callback: function($$v) {
                                  _vm.$set(item, "judicialStatus", $$v)
                                },
                                expression: "item.judicialStatus"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "TableCell",
                          [
                            _c("RenderPhoneColumnValue", {
                              attrs: { phoneNumber: item.phone }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "TableCell",
                          [
                            _c("b-form-datepicker", {
                              staticStyle: {
                                width: "150px",
                                height: "30px",
                                position: "initial !important"
                              },
                              attrs: {
                                placeholder: "Data",
                                "date-format-options": {
                                  day: "numeric",
                                  month: "numeric",
                                  year: "numeric"
                                },
                                locale: "pt-BR"
                              },
                              on: {
                                input: function($event) {
                                  return _vm.setDateToPaid(
                                    item.dateToPaid,
                                    item.id
                                  )
                                }
                              },
                              model: {
                                value: item.dateToPaid,
                                callback: function($$v) {
                                  _vm.$set(item, "dateToPaid", $$v)
                                },
                                expression: "item.dateToPaid"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("TableCell", [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.responsible) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "TableCell",
                          [
                            item.accountManagerName
                              ? _c("RenderNameColumnValue", {
                                  attrs: { name: item.accountManagerName }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("TableCell", [
                          _c(
                            "div",
                            { staticStyle: { display: "flex", gap: "0.2rem" } },
                            [
                              _c(
                                "b-overlay",
                                {
                                  staticClass: "d-inline-block",
                                  attrs: {
                                    show: _vm.busyButton,
                                    rounded: "",
                                    opacity: "0.6",
                                    "spinner-small": "",
                                    "spinner-variant": "outline-primary"
                                  }
                                },
                                [
                                  _c(
                                    "BaseButtonComponent",
                                    {
                                      staticStyle: { padding: "1px 12px" },
                                      attrs: {
                                        disabled: !item.observation,
                                        variant: "tertiary-action"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.recordObservation(item)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Gravar\n                "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-textarea",
                                {
                                  staticStyle: {
                                    "border-radius": "4px",
                                    outline: "none",
                                    border: "1px solid grey",
                                    width: "244px",
                                    height: "30px"
                                  },
                                  attrs: {
                                    id: "textarea",
                                    debounce: "1000",
                                    placeholder: "Observação",
                                    rows: "3",
                                    "max-rows": "6"
                                  },
                                  model: {
                                    value: item.observation,
                                    callback: function($$v) {
                                      _vm.$set(item, "observation", $$v)
                                    },
                                    expression: "item.observation"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.observation) +
                                      "\n              "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "TableCell",
                          [
                            _c("b-form-checkbox", {
                              attrs: {
                                checked: Boolean(item.isSentToSerasa),
                                value: 1,
                                "unchecked-value": 0
                              },
                              on: {
                                change: function($event) {
                                  _vm.setIsSentToSerasa(
                                    Boolean(item.isSentToSerasa),
                                    item.id
                                  )
                                }
                              },
                              model: {
                                value: item.isSentToSerasa,
                                callback: function($$v) {
                                  _vm.$set(item, "isSentToSerasa", $$v)
                                },
                                expression: "item.isSentToSerasa"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "TableCell",
                          [
                            _c("b-form-checkbox", {
                              attrs: {
                                checked: Boolean(item.isSentToProtest),
                                value: 1,
                                "unchecked-value": 0
                              },
                              on: {
                                change: function($event) {
                                  _vm.setIsSentToProtest(
                                    Boolean(item.isSentToProtest),
                                    item.id
                                  )
                                }
                              },
                              model: {
                                value: item.isSentToProtest,
                                callback: function($$v) {
                                  _vm.$set(item, "isSentToProtest", $$v)
                                },
                                expression: "item.isSentToProtest"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "TableCell",
                          [
                            _c("b-form-checkbox", {
                              attrs: {
                                checked: Boolean(item.isSentToSmallClaims),
                                value: 1,
                                "unchecked-value": 0
                              },
                              on: {
                                change: function($event) {
                                  _vm.setIsSentToSmallClaims(
                                    Boolean(item.isSentToSmallClaims),
                                    item.id
                                  )
                                }
                              },
                              model: {
                                value: item.isSentToSmallClaims,
                                callback: function($$v) {
                                  _vm.$set(item, "isSentToSmallClaims", $$v)
                                },
                                expression: "item.isSentToSmallClaims"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "TableCell",
                          [
                            _c("b-form-checkbox", {
                              attrs: {
                                checked: Boolean(item.isSentToFriendlyNotify),
                                value: 1,
                                "unchecked-value": 0
                              },
                              on: {
                                change: function($event) {
                                  _vm.setIsSentToFriendlyNotify(
                                    Boolean(item.isSentToFriendlyNotify),
                                    item.id
                                  )
                                }
                              },
                              model: {
                                value: item.isSentToFriendlyNotify,
                                callback: function($$v) {
                                  _vm.$set(item, "isSentToFriendlyNotify", $$v)
                                },
                                expression: "item.isSentToFriendlyNotify"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "TableCell",
                          [
                            _c("b-form-checkbox", {
                              attrs: {
                                checked: Boolean(item.isSentToExtrajudicial),
                                value: 1,
                                "unchecked-value": 0
                              },
                              on: {
                                change: function($event) {
                                  _vm.setIsSentToExtrajudicial(
                                    Boolean(item.isSentToExtrajudicial),
                                    item.id
                                  )
                                }
                              },
                              model: {
                                value: item.isSentToExtrajudicial,
                                callback: function($$v) {
                                  _vm.$set(item, "isSentToExtrajudicial", $$v)
                                },
                                expression: "item.isSentToExtrajudicial"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("TableCell", [
                          _c(
                            "div",
                            { staticStyle: { display: "flex", gap: "0.2rem" } },
                            [
                              _c("SendEmailInvoiceButton", {
                                attrs: {
                                  month: item.month,
                                  year: item.year,
                                  "installation-number": item.installationNumber
                                }
                              }),
                              _vm._v(" "),
                              _c("SendHsmInvoiceButton", {
                                attrs: {
                                  month: item.month,
                                  year: item.year,
                                  "installation-number": item.installationNumber
                                }
                              })
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "TableCell",
                          [
                            _c("MarkInvoiceToPaidButton", {
                              attrs: { invoice: item },
                              on: { reload: _vm.removeOverdueInvoiceToList }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "TableCell",
                          [
                            _c("RenderNameColumnValue", {
                              attrs: { name: item.nameTrader || "" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "TableCell",
                          { staticStyle: { "text-align": "right" } },
                          [
                            _c("RenderMoneyColumnValue", {
                              attrs: { value: item.consumerEconomy || 0 }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "TableCell",
                          { staticStyle: { "text-align": "right" } },
                          [
                            _c("RenderKwhColumnValue", {
                              attrs: { value: item.totalConsumption || 0 }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "TableCell",
                          { staticStyle: { "text-align": "right" } },
                          [
                            _c("RenderKwhColumnValue", {
                              attrs: { value: item.compensatedEnergy || 0 }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "TableCell",
                          { staticStyle: { "text-align": "right" } },
                          [
                            _c("RenderKwhColumnValue", {
                              attrs: { value: item.accumulatedBalance || 0 }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "TableCell",
                          [
                            _c("RenderSocialNumberColumnValue", {
                              attrs: { "social-number": item.socialNumber }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("TableCell", [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.distributorName) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("TableCell", [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.state) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("TableCell", [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.city) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("TableCell", [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                item.lineTwo
                                  ? `${item.address}, ${item.number}, ${item.lineTwo}, ${item.district}`
                                  : `${item.address}, ${item.number}, ${item.district}`
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "TableCell",
                          [
                            _c("RenderZipCodeColumnValue", {
                              attrs: { "zip-code": item.zipCode }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("TableCell", [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.email) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "TableCell",
                          { staticStyle: { "text-align": "right" } },
                          [
                            _c("RenderDateColumnValue", {
                              attrs: { value: item.userCreatedAt }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("TableCell", [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.linhaDigitavel) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("TableCell", [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.erpId) +
                              "\n          "
                          )
                        ])
                      ],
                      1
                    )
                  }),
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }